export default __webpack_public_path__ + "static/media/Man.3916cc29.svg";